module.exports = __webpack_public_path__ + "img/background.65c96684.jpg";